import axios from "axios";
import {
    CREATE_EQUIPMENT,
    CREATE_EQUIPMENT_REQUEST,
    CREATE_EQUIPMENT_FAIL,
    SUBMIT_EQUIPMENT,
    SUBMIT_EQUIPMENT_REQUEST,
    SUBMIT_EQUIPMENT_FAIL,
    UPDATE_EQUIPMENT,
    UPDATE_EQUIPMENT_REQUEST,
    UPDATE_EQUIPMENT_FAIL,
    SET_EQUIPMENT_DRAFT,
    SET_EQUIPMENT_DRAFT_REQUEST,
    SET_EQUIPMENT_DRAFT_FAIL,
    SET_EQUIPMENT_SERVICED,
    SET_EQUIPMENT_SERVICED_REQUEST,
    SET_EQUIPMENT_SERVICED_FAIL,
    GET_EQUIPMENT,
    GET_EQUIPMENT_REQUEST,
    GET_EQUIPMENT_FAIL,
    GET_EQUIPMENTS,
    GET_EQUIPMENTS_REQUEST,
    GET_EQUIPMENTS_FAIL,
    GET_EQUIPMENTS_BY_USER,
    GET_EQUIPMENTS_BY_USER_REQUEST,
    GET_EQUIPMENTS_BY_USER_FAIL,
    GET_EQUIPMENTS_BY_LOCATION,
    GET_EQUIPMENTS_BY_LOCATION_REQUEST,
    GET_EQUIPMENTS_BY_LOCATION_FAIL,
    DELETE_EQUIPMENT,
    DELETE_EQUIPMENT_REQUEST,
    DELETE_EQUIPMENT_FAIL,

} from "../types/equipmentTypes"

const token = localStorage.getItem("token:data");
export const createInspection = (equipment) => async (dispatch) => {
    
    try {
        dispatch({
            type: CREATE_EQUIPMENT_REQUEST,
        });
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const { data } = await axios.post(`/api/v1/equipment/inspection`, equipment, config);
        dispatch({
            type: CREATE_EQUIPMENT,
            payload: data,
        });
        return data;
    } catch (error) {
        const errorMessage =
            error.response && error.response.data.error
                ? error.response.data.error
                : error.request
                ? error.request.data.error
                : error.message;
        dispatch({
            type: CREATE_EQUIPMENT_FAIL,
            payload: errorMessage,
        });
        throw new Error(errorMessage);
    }
}

export const submitInspection = (equipment) => async (dispatch) => {
    
    try {
        dispatch({
            type: SUBMIT_EQUIPMENT_REQUEST,
        });
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const { data } = await axios.post(`/api/v1/equipment/inspection/submit`, equipment, config);
        dispatch({
            type: SUBMIT_EQUIPMENT,
            payload: data,
        });
        return data;
    } catch (error) {
        const errorMessage =
            error.response && error.response.data.error
                ? error.response.data.error
                : error.request
                ? error.request.data.error
                : error.message;
        dispatch({
            type: SUBMIT_EQUIPMENT_FAIL,
            payload: errorMessage,
        });
        throw new Error(errorMessage);
    }
}


export const updateInspection = (equipment) => async (dispatch) => {
    
    try {
        dispatch({
            type: UPDATE_EQUIPMENT_REQUEST,
        });
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const { data } = await axios.put(`/api/v1/equipment/inspection/${equipment.id}`, equipment, config);
        dispatch({
            type: UPDATE_EQUIPMENT,
            payload: data,
        });
        return data;
    } catch (error) {
        const errorMessage =
            error.response && error.response.data.error
                ? error.response.data.error
                : error.request
                ? error.request.data.error
                : error.message;
        dispatch({
            type: UPDATE_EQUIPMENT_FAIL,
            payload: errorMessage,
        });
        throw new Error(errorMessage);
    }
}

export const setInspectionDraft = (id) => async (dispatch) => {
    
    try {
        dispatch({
            type: SET_EQUIPMENT_DRAFT_REQUEST
        });
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const { data } = await axios.put(`/api/v1/equipment/inspection/draft/${id}`, null, config);
        dispatch({
            type: SET_EQUIPMENT_DRAFT,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: SET_EQUIPMENT_DRAFT_FAIL,
            payload:
                error.response && error.response.data.error
                ? error.response.data.error
                : error.request 
                ? error.request.data.error
                : error.message,
        });
    }
}

export const setInspectionServiced = (service) => async (dispatch) => {
    
    try {
        dispatch({
            type: SET_EQUIPMENT_SERVICED_REQUEST
        });
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const { data } = await axios.put(`/api/v1/equipment/inspection/serviced/${service.id}`, service, config);
        dispatch({
            type: SET_EQUIPMENT_SERVICED,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: SET_EQUIPMENT_SERVICED_FAIL,
            payload:
                error.response && error.response.data.error
                ? error.response.data.error
                : error.request 
                ? error.request.data.error
                : error.message,
        });
    }
}


export const getInspections = () => async (dispatch) => {
    
    try {
        dispatch({
            type: GET_EQUIPMENTS_REQUEST,
        });
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const { data } = await axios.get(`/api/v1/equipment/inspections`, config);
        dispatch({
            type: GET_EQUIPMENTS,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: GET_EQUIPMENTS_FAIL,
            payload:
                error.response && error.response.data.error
                ? error.response.data.error
                : error.request
                ? error.request.data.error
                : error.message,
                });
    }
}

export const getInspection = (id) => async (dispatch) => {
    
    try {
        dispatch({
            type: GET_EQUIPMENT_REQUEST,
        });
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        const { data } = await axios.get(`/api/v1/equipment/inspection/${id}`, config);
        dispatch({
            type: GET_EQUIPMENT,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: GET_EQUIPMENT_FAIL,
            payload:
                error.response && error.response.data?.error
                ? error.response.data?.error
                : error.request
                ? error.request.data?.error
                : error.message,
        });
    }
}

export const getInspectionsByUser = () => async (dispatch) => {
   
    try {
        dispatch({
            type: GET_EQUIPMENTS_BY_USER_REQUEST,
        });
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        let { data } = await axios.get(`/api/v1/equipment/myinspections/user`, config);
        dispatch({
            type: GET_EQUIPMENTS_BY_USER,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: GET_EQUIPMENTS_BY_USER_FAIL,
            payload:
                error.response && error.response.data.error
                ? error.response.data.error
                : error.request
                ? error.request.data.error
                : error.message,
        });
    }
}


export const getInspectionsByLocation = (id) => async (dispatch) => {
   
    try {
        dispatch({
            type: GET_EQUIPMENTS_BY_LOCATION_REQUEST,
        });
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        let { data } = await axios.get(`/api/v1/equipment/inspections/location/${id}`, config);
        dispatch({
            type: GET_EQUIPMENTS_BY_LOCATION,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: GET_EQUIPMENTS_BY_LOCATION_FAIL,
            payload:
                error.response && error.response.data.error
                ? error.response.data.error
                : error.request
                ? error.request.data.error
                : error.message,
        });
    }
}

export const deleteInspection = (id) => async (dispatch) => {
    try {
        dispatch({
            type: DELETE_EQUIPMENT_REQUEST,
        });
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        await axios.delete(`/api/v1/equipment/inspection/${id}`, config);
        dispatch({
            type: DELETE_EQUIPMENT,
        });
    } catch (error) {
        dispatch({
            type: DELETE_EQUIPMENT_FAIL,
            payload:
                error.response && error.response.data.error
                ? error.response.data.error
                : error.request
                ? error.request.data.error
                : error.message,
        });
    }
}

